/* RESPONSIBLE TEAM: team-ai-insights */

import type { CxBenchmarkData } from 'embercom/components/reporting/bespoke/fin-performance/cx-benchmark-panel/types';

// Generated from Snowflake data for 2026-03.
// Extraction tooling (SQL + Python transform) lives in the intercom repo.
export const CX_BENCHMARK_DATA: CxBenchmarkData = {
  benchmarks: {
    'ecommerce:15k_to_100k': {
      percentiles: {
        p5: 0.3588,
        p10: 0.4788,
        p15: 0.5277,
        p20: 0.5568,
        p25: 0.5774,
        p30: 0.5877,
        p35: 0.6037,
        p40: 0.6234,
        p45: 0.6331,
        p50: 0.6643,
        p55: 0.6798,
        p60: 0.6906,
        p65: 0.7037,
        p70: 0.7109,
        p75: 0.7266,
        p80: 0.753,
        p85: 0.7722,
        p90: 0.8276,
        p95: 0.8391,
        p100: 0.8769,
      },
      reasons: {
        answer_quality_bot_high: 0.7793,
        answer_quality_bot_low: 0.0553,
        product_feedback_positive: 0.0105,
        product_feedback_negative: 0.136,
        policy_feedback_positive: 0.0012,
        policy_feedback_negative: 0.1015,
        user_strong_emotion_positive: 0.0114,
        user_strong_emotion_negative: 0.0831,
        user_effort_low: 0.561,
        user_effort_high: 0.2005,
      },
      score_distribution: {
        score_1: 0.0085,
        score_2: 0.1165,
        score_3: 0.2117,
        score_4: 0.218,
        score_5: 0.4407,
      },
    },

    'ecommerce:1k_to_15k': {
      percentiles: {
        p5: 0.4675,
        p10: 0.5572,
        p15: 0.5936,
        p20: 0.6051,
        p25: 0.6152,
        p30: 0.6285,
        p35: 0.6396,
        p40: 0.6643,
        p45: 0.6858,
        p50: 0.6967,
        p55: 0.7092,
        p60: 0.7327,
        p65: 0.7417,
        p70: 0.7487,
        p75: 0.7666,
        p80: 0.7919,
        p85: 0.8197,
        p90: 0.8294,
        p95: 0.8764,
        p100: 0.9726,
      },
      reasons: {
        answer_quality_bot_high: 0.75,
        answer_quality_bot_low: 0.0651,
        product_feedback_positive: 0.0084,
        product_feedback_negative: 0.126,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0863,
        user_strong_emotion_positive: 0.0097,
        user_strong_emotion_negative: 0.0571,
        user_effort_low: 0.5323,
        user_effort_high: 0.2283,
      },
      score_distribution: {
        score_1: 0.0047,
        score_2: 0.116,
        score_3: 0.1643,
        score_4: 0.2154,
        score_5: 0.4688,
      },
    },

    'ecommerce:overall': {
      percentiles: {
        p5: 0.3844,
        p10: 0.5088,
        p15: 0.5675,
        p20: 0.5917,
        p25: 0.6061,
        p30: 0.6177,
        p35: 0.6344,
        p40: 0.6584,
        p45: 0.6777,
        p50: 0.687,
        p55: 0.6984,
        p60: 0.7112,
        p65: 0.736,
        p70: 0.7465,
        p75: 0.7657,
        p80: 0.7956,
        p85: 0.8195,
        p90: 0.8384,
        p95: 0.8767,
        p100: 0.9726,
      },
      reasons: {
        answer_quality_bot_high: 0.7549,
        answer_quality_bot_low: 0.0601,
        product_feedback_positive: 0.0087,
        product_feedback_negative: 0.135,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0847,
        user_strong_emotion_positive: 0.009,
        user_strong_emotion_negative: 0.0574,
        user_effort_low: 0.5384,
        user_effort_high: 0.2266,
      },
      score_distribution: {
        score_1: 0.0061,
        score_2: 0.1158,
        score_3: 0.1737,
        score_4: 0.2169,
        score_5: 0.463,
      },
    },

    'ecommerce:under_1k': {
      percentiles: {
        p5: 0.4122,
        p10: 0.5206,
        p15: 0.5821,
        p20: 0.6015,
        p25: 0.6432,
        p30: 0.6672,
        p35: 0.6688,
        p40: 0.6776,
        p45: 0.688,
        p50: 0.6984,
        p55: 0.7386,
        p60: 0.7609,
        p65: 0.788,
        p70: 0.7954,
        p75: 0.8037,
        p80: 0.8153,
        p85: 0.8348,
        p90: 0.8544,
        p95: 0.8907,
        p100: 0.9062,
      },
      reasons: {
        answer_quality_bot_high: 0.768,
        answer_quality_bot_low: 0.0598,
        product_feedback_positive: 0.0024,
        product_feedback_negative: 0.1693,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0531,
        user_strong_emotion_positive: 0.0,
        user_strong_emotion_negative: 0.0465,
        user_effort_low: 0.4648,
        user_effort_high: 0.2904,
      },
      score_distribution: {
        score_1: 0.0,
        score_2: 0.0965,
        score_3: 0.1463,
        score_4: 0.2181,
        score_5: 0.4924,
      },
    },

    'education:1k_to_15k': {
      percentiles: {
        p5: 0.4738,
        p10: 0.5252,
        p15: 0.5882,
        p20: 0.6065,
        p25: 0.6305,
        p30: 0.6503,
        p35: 0.67,
        p40: 0.6813,
        p45: 0.7117,
        p50: 0.7202,
        p55: 0.7375,
        p60: 0.7504,
        p65: 0.7765,
        p70: 0.7831,
        p75: 0.7888,
        p80: 0.811,
        p85: 0.8224,
        p90: 0.8459,
        p95: 0.865,
        p100: 0.9781,
      },
      reasons: {
        answer_quality_bot_high: 0.7687,
        answer_quality_bot_low: 0.0494,
        product_feedback_positive: 0.004,
        product_feedback_negative: 0.1061,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0478,
        user_strong_emotion_positive: 0.0078,
        user_strong_emotion_negative: 0.0455,
        user_effort_low: 0.5013,
        user_effort_high: 0.2525,
      },
      score_distribution: {
        score_1: 0.0033,
        score_2: 0.094,
        score_3: 0.1573,
        score_4: 0.2138,
        score_5: 0.5018,
      },
    },

    'education:overall': {
      percentiles: {
        p5: 0.4792,
        p10: 0.5269,
        p15: 0.5971,
        p20: 0.6114,
        p25: 0.6354,
        p30: 0.6555,
        p35: 0.6726,
        p40: 0.6909,
        p45: 0.7118,
        p50: 0.7193,
        p55: 0.7379,
        p60: 0.7525,
        p65: 0.7681,
        p70: 0.7803,
        p75: 0.7874,
        p80: 0.8048,
        p85: 0.8209,
        p90: 0.8448,
        p95: 0.8782,
        p100: 0.9781,
      },
      reasons: {
        answer_quality_bot_high: 0.7661,
        answer_quality_bot_low: 0.0513,
        product_feedback_positive: 0.0043,
        product_feedback_negative: 0.1087,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0473,
        user_strong_emotion_positive: 0.0084,
        user_strong_emotion_negative: 0.0488,
        user_effort_low: 0.5119,
        user_effort_high: 0.2519,
      },
      score_distribution: {
        score_1: 0.0037,
        score_2: 0.0957,
        score_3: 0.1583,
        score_4: 0.2112,
        score_5: 0.5036,
      },
    },

    'education:under_1k': {
      percentiles: {
        p5: 0.5737,
        p10: 0.6166,
        p15: 0.6301,
        p20: 0.6449,
        p25: 0.6642,
        p30: 0.685,
        p35: 0.7132,
        p40: 0.7252,
        p45: 0.747,
        p50: 0.7538,
        p55: 0.7613,
        p60: 0.769,
        p65: 0.783,
        p70: 0.7936,
        p75: 0.8042,
        p80: 0.8223,
        p85: 0.8354,
        p90: 0.8479,
        p95: 0.901,
        p100: 0.9565,
      },
      reasons: {
        answer_quality_bot_high: 0.7843,
        answer_quality_bot_low: 0.0568,
        product_feedback_positive: 0.0,
        product_feedback_negative: 0.1168,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0271,
        user_strong_emotion_positive: 0.0,
        user_strong_emotion_negative: 0.0377,
        user_effort_low: 0.5243,
        user_effort_high: 0.2536,
      },
      score_distribution: {
        score_1: 0.0,
        score_2: 0.0897,
        score_3: 0.1555,
        score_4: 0.2085,
        score_5: 0.518,
      },
    },

    'energy:overall': {
      percentiles: {
        p5: 0.4582,
        p10: 0.4914,
        p15: 0.4995,
        p20: 0.5178,
        p25: 0.5423,
        p30: 0.5943,
        p35: 0.6011,
        p40: 0.6093,
        p45: 0.6341,
        p50: 0.6417,
        p55: 0.6486,
        p60: 0.6739,
        p65: 0.6799,
        p70: 0.7118,
        p75: 0.7193,
        p80: 0.7467,
        p85: 0.7779,
        p90: 0.7887,
        p95: 0.8128,
        p100: 0.8442,
      },
      reasons: {
        answer_quality_bot_high: 0.7027,
        answer_quality_bot_low: 0.0773,
        product_feedback_positive: 0.0038,
        product_feedback_negative: 0.1161,
        policy_feedback_positive: 0.0002,
        policy_feedback_negative: 0.0605,
        user_strong_emotion_positive: 0.0032,
        user_strong_emotion_negative: 0.0722,
        user_effort_low: 0.4965,
        user_effort_high: 0.2919,
      },
      score_distribution: {
        score_1: 0.0076,
        score_2: 0.1423,
        score_3: 0.1933,
        score_4: 0.2049,
        score_5: 0.433,
      },
    },

    'fintech:15k_to_100k': {
      percentiles: {
        p5: 0.3899,
        p10: 0.4621,
        p15: 0.5151,
        p20: 0.5467,
        p25: 0.5801,
        p30: 0.59,
        p35: 0.6049,
        p40: 0.6186,
        p45: 0.6343,
        p50: 0.645,
        p55: 0.6678,
        p60: 0.6902,
        p65: 0.7046,
        p70: 0.725,
        p75: 0.7381,
        p80: 0.7678,
        p85: 0.7949,
        p90: 0.8178,
        p95: 0.8423,
        p100: 0.9497,
      },
      reasons: {
        answer_quality_bot_high: 0.7293,
        answer_quality_bot_low: 0.0696,
        product_feedback_positive: 0.0042,
        product_feedback_negative: 0.077,
        policy_feedback_positive: 0.001,
        policy_feedback_negative: 0.0883,
        user_strong_emotion_positive: 0.0048,
        user_strong_emotion_negative: 0.0809,
        user_effort_low: 0.5172,
        user_effort_high: 0.2535,
      },
      score_distribution: {
        score_1: 0.0063,
        score_2: 0.1311,
        score_3: 0.1801,
        score_4: 0.206,
        score_5: 0.4337,
      },
    },

    'fintech:1k_to_15k': {
      percentiles: {
        p5: 0.3962,
        p10: 0.4711,
        p15: 0.5151,
        p20: 0.5378,
        p25: 0.5658,
        p30: 0.5869,
        p35: 0.6117,
        p40: 0.6234,
        p45: 0.6368,
        p50: 0.6659,
        p55: 0.6768,
        p60: 0.6921,
        p65: 0.7087,
        p70: 0.7283,
        p75: 0.7494,
        p80: 0.7704,
        p85: 0.7901,
        p90: 0.8169,
        p95: 0.8531,
        p100: 0.973,
      },
      reasons: {
        answer_quality_bot_high: 0.7273,
        answer_quality_bot_low: 0.0686,
        product_feedback_positive: 0.0049,
        product_feedback_negative: 0.1095,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0697,
        user_strong_emotion_positive: 0.0044,
        user_strong_emotion_negative: 0.0581,
        user_effort_low: 0.4797,
        user_effort_high: 0.2816,
      },
      score_distribution: {
        score_1: 0.0068,
        score_2: 0.1333,
        score_3: 0.1806,
        score_4: 0.2211,
        score_5: 0.4248,
      },
    },

    'fintech:overall': {
      percentiles: {
        p5: 0.3944,
        p10: 0.4624,
        p15: 0.5151,
        p20: 0.5426,
        p25: 0.5679,
        p30: 0.5876,
        p35: 0.6075,
        p40: 0.6254,
        p45: 0.6382,
        p50: 0.6601,
        p55: 0.6771,
        p60: 0.6975,
        p65: 0.7123,
        p70: 0.733,
        p75: 0.7517,
        p80: 0.7727,
        p85: 0.7949,
        p90: 0.8222,
        p95: 0.8556,
        p100: 0.973,
      },
      reasons: {
        answer_quality_bot_high: 0.7327,
        answer_quality_bot_low: 0.0696,
        product_feedback_positive: 0.0036,
        product_feedback_negative: 0.0968,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.074,
        user_strong_emotion_positive: 0.0043,
        user_strong_emotion_negative: 0.064,
        user_effort_low: 0.4898,
        user_effort_high: 0.27,
      },
      score_distribution: {
        score_1: 0.0063,
        score_2: 0.1311,
        score_3: 0.1799,
        score_4: 0.2118,
        score_5: 0.4284,
      },
    },

    'fintech:under_1k': {
      percentiles: {
        p5: 0.4979,
        p10: 0.531,
        p15: 0.5531,
        p20: 0.5741,
        p25: 0.5862,
        p30: 0.6201,
        p35: 0.6336,
        p40: 0.6481,
        p45: 0.6598,
        p50: 0.6769,
        p55: 0.7064,
        p60: 0.7252,
        p65: 0.7436,
        p70: 0.7671,
        p75: 0.7727,
        p80: 0.7794,
        p85: 0.8076,
        p90: 0.836,
        p95: 0.8799,
        p100: 0.92,
      },
      reasons: {
        answer_quality_bot_high: 0.758,
        answer_quality_bot_low: 0.0771,
        product_feedback_positive: 0.0,
        product_feedback_negative: 0.1082,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0366,
        user_strong_emotion_positive: 0.0,
        user_strong_emotion_negative: 0.042,
        user_effort_low: 0.505,
        user_effort_high: 0.275,
      },
      score_distribution: {
        score_1: 0.0,
        score_2: 0.1192,
        score_3: 0.1734,
        score_4: 0.2092,
        score_5: 0.4419,
      },
    },

    'gaming_and_gambling:1k_to_15k': {
      percentiles: {
        p5: 0.2877,
        p10: 0.3251,
        p15: 0.3647,
        p20: 0.397,
        p25: 0.4164,
        p30: 0.4507,
        p35: 0.4746,
        p40: 0.4957,
        p45: 0.5213,
        p50: 0.5345,
        p55: 0.5485,
        p60: 0.5597,
        p65: 0.5887,
        p70: 0.624,
        p75: 0.6397,
        p80: 0.66,
        p85: 0.6688,
        p90: 0.6914,
        p95: 0.6989,
        p100: 0.7903,
      },
      reasons: {
        answer_quality_bot_high: 0.663,
        answer_quality_bot_low: 0.0824,
        product_feedback_positive: 0.003,
        product_feedback_negative: 0.1439,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.1132,
        user_strong_emotion_positive: 0.0082,
        user_strong_emotion_negative: 0.129,
        user_effort_low: 0.4261,
        user_effort_high: 0.2951,
      },
      score_distribution: {
        score_1: 0.0231,
        score_2: 0.1884,
        score_3: 0.2447,
        score_4: 0.1901,
        score_5: 0.3134,
      },
    },

    'gaming_and_gambling:overall': {
      percentiles: {
        p5: 0.3247,
        p10: 0.3669,
        p15: 0.3996,
        p20: 0.4567,
        p25: 0.4854,
        p30: 0.4944,
        p35: 0.5187,
        p40: 0.5345,
        p45: 0.5552,
        p50: 0.561,
        p55: 0.5654,
        p60: 0.5734,
        p65: 0.5951,
        p70: 0.6214,
        p75: 0.6424,
        p80: 0.648,
        p85: 0.6698,
        p90: 0.6984,
        p95: 0.7305,
        p100: 0.9256,
      },
      reasons: {
        answer_quality_bot_high: 0.6714,
        answer_quality_bot_low: 0.0821,
        product_feedback_positive: 0.0022,
        product_feedback_negative: 0.1374,
        policy_feedback_positive: 0.0001,
        policy_feedback_negative: 0.1385,
        user_strong_emotion_positive: 0.0047,
        user_strong_emotion_negative: 0.1178,
        user_effort_low: 0.4236,
        user_effort_high: 0.289,
      },
      score_distribution: {
        score_1: 0.0193,
        score_2: 0.1725,
        score_3: 0.2424,
        score_4: 0.2024,
        score_5: 0.3367,
      },
    },

    'healthcare:1k_to_15k': {
      percentiles: {
        p5: 0.4434,
        p10: 0.5,
        p15: 0.5664,
        p20: 0.5877,
        p25: 0.6188,
        p30: 0.6285,
        p35: 0.6431,
        p40: 0.6575,
        p45: 0.6746,
        p50: 0.6927,
        p55: 0.7132,
        p60: 0.7241,
        p65: 0.7397,
        p70: 0.7563,
        p75: 0.7666,
        p80: 0.7778,
        p85: 0.8003,
        p90: 0.8269,
        p95: 0.8555,
        p100: 0.9333,
      },
      reasons: {
        answer_quality_bot_high: 0.7568,
        answer_quality_bot_low: 0.0678,
        product_feedback_positive: 0.0056,
        product_feedback_negative: 0.1092,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0488,
        user_strong_emotion_positive: 0.0066,
        user_strong_emotion_negative: 0.0551,
        user_effort_low: 0.5236,
        user_effort_high: 0.25,
      },
      score_distribution: {
        score_1: 0.0047,
        score_2: 0.1141,
        score_3: 0.1698,
        score_4: 0.2084,
        score_5: 0.4637,
      },
    },

    'healthcare:overall': {
      percentiles: {
        p5: 0.4089,
        p10: 0.4905,
        p15: 0.5346,
        p20: 0.5817,
        p25: 0.6105,
        p30: 0.6229,
        p35: 0.6405,
        p40: 0.6594,
        p45: 0.6797,
        p50: 0.6935,
        p55: 0.7098,
        p60: 0.7207,
        p65: 0.7324,
        p70: 0.7467,
        p75: 0.7674,
        p80: 0.7903,
        p85: 0.8065,
        p90: 0.8235,
        p95: 0.8524,
        p100: 0.9333,
      },
      reasons: {
        answer_quality_bot_high: 0.7419,
        answer_quality_bot_low: 0.0617,
        product_feedback_positive: 0.0037,
        product_feedback_negative: 0.109,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0549,
        user_strong_emotion_positive: 0.0052,
        user_strong_emotion_negative: 0.0538,
        user_effort_low: 0.5268,
        user_effort_high: 0.2455,
      },
      score_distribution: {
        score_1: 0.0051,
        score_2: 0.1178,
        score_3: 0.1701,
        score_4: 0.2082,
        score_5: 0.4682,
      },
    },

    'healthcare:under_1k': {
      percentiles: {
        p5: 0.406,
        p10: 0.495,
        p15: 0.5352,
        p20: 0.5823,
        p25: 0.6266,
        p30: 0.6387,
        p35: 0.6667,
        p40: 0.6854,
        p45: 0.6928,
        p50: 0.7,
        p55: 0.7224,
        p60: 0.7313,
        p65: 0.7739,
        p70: 0.8028,
        p75: 0.8033,
        p80: 0.8065,
        p85: 0.8131,
        p90: 0.825,
        p95: 0.8433,
        p100: 0.9067,
      },
      reasons: {
        answer_quality_bot_high: 0.7692,
        answer_quality_bot_low: 0.05,
        product_feedback_positive: 0.0,
        product_feedback_negative: 0.1224,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0294,
        user_strong_emotion_positive: 0.0,
        user_strong_emotion_negative: 0.037,
        user_effort_low: 0.5254,
        user_effort_high: 0.2222,
      },
      score_distribution: {
        score_1: 0.0,
        score_2: 0.1043,
        score_3: 0.1742,
        score_4: 0.2141,
        score_5: 0.4858,
      },
    },

    'hospitality_and_tourism:overall': {
      percentiles: {
        p5: 0.4807,
        p10: 0.5453,
        p15: 0.5867,
        p20: 0.6224,
        p25: 0.6297,
        p30: 0.6479,
        p35: 0.6758,
        p40: 0.6877,
        p45: 0.6922,
        p50: 0.7024,
        p55: 0.7097,
        p60: 0.7406,
        p65: 0.7521,
        p70: 0.7736,
        p75: 0.7931,
        p80: 0.8094,
        p85: 0.8274,
        p90: 0.8423,
        p95: 0.903,
        p100: 0.927,
      },
      reasons: {
        answer_quality_bot_high: 0.7692,
        answer_quality_bot_low: 0.0506,
        product_feedback_positive: 0.0037,
        product_feedback_negative: 0.0769,
        policy_feedback_positive: 0.0007,
        policy_feedback_negative: 0.0723,
        user_strong_emotion_positive: 0.0055,
        user_strong_emotion_negative: 0.0455,
        user_effort_low: 0.5388,
        user_effort_high: 0.2172,
      },
      score_distribution: {
        score_1: 0.0041,
        score_2: 0.102,
        score_3: 0.1619,
        score_4: 0.2211,
        score_5: 0.4584,
      },
    },

    'manufacturing:1k_to_15k': {
      percentiles: {
        p5: 0.4734,
        p10: 0.5893,
        p15: 0.6026,
        p20: 0.6302,
        p25: 0.6379,
        p30: 0.6724,
        p35: 0.7153,
        p40: 0.7424,
        p45: 0.7537,
        p50: 0.7651,
        p55: 0.7744,
        p60: 0.7776,
        p65: 0.7859,
        p70: 0.7973,
        p75: 0.802,
        p80: 0.8056,
        p85: 0.8168,
        p90: 0.8355,
        p95: 0.8668,
        p100: 0.8894,
      },
      reasons: {
        answer_quality_bot_high: 0.8562,
        answer_quality_bot_low: 0.0526,
        product_feedback_positive: 0.0158,
        product_feedback_negative: 0.0831,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0421,
        user_strong_emotion_positive: 0.0088,
        user_strong_emotion_negative: 0.0421,
        user_effort_low: 0.6411,
        user_effort_high: 0.1391,
      },
      score_distribution: {
        score_1: 0.0081,
        score_2: 0.0769,
        score_3: 0.1591,
        score_4: 0.1843,
        score_5: 0.5449,
      },
    },

    'manufacturing:overall': {
      percentiles: {
        p5: 0.4655,
        p10: 0.5399,
        p15: 0.5856,
        p20: 0.6021,
        p25: 0.6312,
        p30: 0.6521,
        p35: 0.6742,
        p40: 0.6957,
        p45: 0.7353,
        p50: 0.7478,
        p55: 0.7546,
        p60: 0.7735,
        p65: 0.7807,
        p70: 0.7964,
        p75: 0.8051,
        p80: 0.8077,
        p85: 0.8199,
        p90: 0.8383,
        p95: 0.868,
        p100: 0.9,
      },
      reasons: {
        answer_quality_bot_high: 0.8402,
        answer_quality_bot_low: 0.0622,
        product_feedback_positive: 0.0077,
        product_feedback_negative: 0.0883,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0361,
        user_strong_emotion_positive: 0.0082,
        user_strong_emotion_negative: 0.0524,
        user_effort_low: 0.5802,
        user_effort_high: 0.206,
      },
      score_distribution: {
        score_1: 0.0068,
        score_2: 0.0902,
        score_3: 0.1604,
        score_4: 0.1941,
        score_5: 0.5295,
      },
    },

    'media_and_entertainment:1k_to_15k': {
      percentiles: {
        p5: 0.4079,
        p10: 0.477,
        p15: 0.5079,
        p20: 0.5188,
        p25: 0.5311,
        p30: 0.5455,
        p35: 0.5624,
        p40: 0.5721,
        p45: 0.5959,
        p50: 0.6139,
        p55: 0.6288,
        p60: 0.6382,
        p65: 0.6757,
        p70: 0.7248,
        p75: 0.7319,
        p80: 0.7442,
        p85: 0.7746,
        p90: 0.805,
        p95: 0.8231,
        p100: 0.838,
      },
      reasons: {
        answer_quality_bot_high: 0.6838,
        answer_quality_bot_low: 0.0736,
        product_feedback_positive: 0.0031,
        product_feedback_negative: 0.1211,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0798,
        user_strong_emotion_positive: 0.0075,
        user_strong_emotion_negative: 0.0883,
        user_effort_low: 0.4505,
        user_effort_high: 0.3098,
      },
      score_distribution: {
        score_1: 0.012,
        score_2: 0.1584,
        score_3: 0.1594,
        score_4: 0.2155,
        score_5: 0.396,
      },
    },

    'media_and_entertainment:overall': {
      percentiles: {
        p5: 0.3995,
        p10: 0.4862,
        p15: 0.5176,
        p20: 0.533,
        p25: 0.5582,
        p30: 0.5629,
        p35: 0.5731,
        p40: 0.59,
        p45: 0.6091,
        p50: 0.6269,
        p55: 0.6396,
        p60: 0.6553,
        p65: 0.7003,
        p70: 0.7276,
        p75: 0.7333,
        p80: 0.7457,
        p85: 0.7665,
        p90: 0.7999,
        p95: 0.8305,
        p100: 0.8444,
      },
      reasons: {
        answer_quality_bot_high: 0.6967,
        answer_quality_bot_low: 0.0732,
        product_feedback_positive: 0.0038,
        product_feedback_negative: 0.1229,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0811,
        user_strong_emotion_positive: 0.0093,
        user_strong_emotion_negative: 0.0905,
        user_effort_low: 0.4481,
        user_effort_high: 0.2902,
      },
      score_distribution: {
        score_1: 0.0118,
        score_2: 0.1584,
        score_3: 0.1572,
        score_4: 0.2154,
        score_5: 0.4052,
      },
    },

    'other:1k_to_15k': {
      percentiles: {
        p5: 0.4502,
        p10: 0.4909,
        p15: 0.5171,
        p20: 0.5458,
        p25: 0.5624,
        p30: 0.5793,
        p35: 0.6334,
        p40: 0.6601,
        p45: 0.6755,
        p50: 0.6901,
        p55: 0.6947,
        p60: 0.7092,
        p65: 0.7264,
        p70: 0.7668,
        p75: 0.8105,
        p80: 0.8479,
        p85: 0.8526,
        p90: 0.892,
        p95: 0.9309,
        p100: 0.9524,
      },
      reasons: {
        answer_quality_bot_high: 0.7848,
        answer_quality_bot_low: 0.0577,
        product_feedback_positive: 0.0036,
        product_feedback_negative: 0.0952,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.059,
        user_strong_emotion_positive: 0.0069,
        user_strong_emotion_negative: 0.0526,
        user_effort_low: 0.5018,
        user_effort_high: 0.2381,
      },
      score_distribution: {
        score_1: 0.0057,
        score_2: 0.1091,
        score_3: 0.1855,
        score_4: 0.2063,
        score_5: 0.4748,
      },
    },

    'other:overall': {
      percentiles: {
        p5: 0.3862,
        p10: 0.461,
        p15: 0.4884,
        p20: 0.5085,
        p25: 0.5452,
        p30: 0.5585,
        p35: 0.5755,
        p40: 0.5984,
        p45: 0.6113,
        p50: 0.6607,
        p55: 0.6898,
        p60: 0.699,
        p65: 0.7282,
        p70: 0.7652,
        p75: 0.7811,
        p80: 0.8216,
        p85: 0.8414,
        p90: 0.8556,
        p95: 0.9119,
        p100: 0.9524,
      },
      reasons: {
        answer_quality_bot_high: 0.7339,
        answer_quality_bot_low: 0.0711,
        product_feedback_positive: 0.0023,
        product_feedback_negative: 0.1009,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.059,
        user_strong_emotion_positive: 0.0046,
        user_strong_emotion_negative: 0.0534,
        user_effort_low: 0.4831,
        user_effort_high: 0.2564,
      },
      score_distribution: {
        score_1: 0.0068,
        score_2: 0.1329,
        score_3: 0.191,
        score_4: 0.2143,
        score_5: 0.4194,
      },
    },

    'overall:100k_to_1m': {
      percentiles: {
        p5: 0.352,
        p10: 0.4048,
        p15: 0.4673,
        p20: 0.5253,
        p25: 0.5535,
        p30: 0.5799,
        p35: 0.6063,
        p40: 0.6195,
        p45: 0.6457,
        p50: 0.6659,
        p55: 0.6825,
        p60: 0.6949,
        p65: 0.7129,
        p70: 0.7243,
        p75: 0.7352,
        p80: 0.7502,
        p85: 0.7709,
        p90: 0.7835,
        p95: 0.8208,
        p100: 0.9208,
      },
      reasons: {
        answer_quality_bot_high: 0.7,
        answer_quality_bot_low: 0.075,
        product_feedback_positive: 0.0022,
        product_feedback_negative: 0.1052,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0414,
        user_strong_emotion_positive: 0.0029,
        user_strong_emotion_negative: 0.0556,
        user_effort_low: 0.3908,
        user_effort_high: 0.3182,
      },
      score_distribution: {
        score_1: 0.0056,
        score_2: 0.1278,
        score_3: 0.1905,
        score_4: 0.2285,
        score_5: 0.4201,
      },
    },

    'overall:15k_to_100k': {
      percentiles: {
        p5: 0.3998,
        p10: 0.4742,
        p15: 0.5159,
        p20: 0.5452,
        p25: 0.5651,
        p30: 0.5828,
        p35: 0.5981,
        p40: 0.612,
        p45: 0.6256,
        p50: 0.6438,
        p55: 0.6679,
        p60: 0.6874,
        p65: 0.7073,
        p70: 0.7206,
        p75: 0.7397,
        p80: 0.7581,
        p85: 0.7821,
        p90: 0.8165,
        p95: 0.8408,
        p100: 0.9497,
      },
      reasons: {
        answer_quality_bot_high: 0.7239,
        answer_quality_bot_low: 0.0657,
        product_feedback_positive: 0.0043,
        product_feedback_negative: 0.1159,
        policy_feedback_positive: 0.0007,
        policy_feedback_negative: 0.08,
        user_strong_emotion_positive: 0.0057,
        user_strong_emotion_negative: 0.075,
        user_effort_low: 0.48,
        user_effort_high: 0.2855,
      },
      score_distribution: {
        score_1: 0.0073,
        score_2: 0.1337,
        score_3: 0.1887,
        score_4: 0.2131,
        score_5: 0.4239,
      },
    },

    'overall:1k_to_15k': {
      percentiles: {
        p5: 0.4298,
        p10: 0.4926,
        p15: 0.5347,
        p20: 0.5696,
        p25: 0.5955,
        p30: 0.6169,
        p35: 0.6368,
        p40: 0.6574,
        p45: 0.6719,
        p50: 0.6897,
        p55: 0.7057,
        p60: 0.7201,
        p65: 0.7347,
        p70: 0.75,
        p75: 0.7692,
        p80: 0.7877,
        p85: 0.8056,
        p90: 0.8286,
        p95: 0.8607,
        p100: 1.0,
      },
      reasons: {
        answer_quality_bot_high: 0.7393,
        answer_quality_bot_low: 0.0631,
        product_feedback_positive: 0.0052,
        product_feedback_negative: 0.1261,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0434,
        user_strong_emotion_positive: 0.0055,
        user_strong_emotion_negative: 0.0536,
        user_effort_low: 0.4653,
        user_effort_high: 0.2857,
      },
      score_distribution: {
        score_1: 0.0054,
        score_2: 0.1174,
        score_3: 0.1696,
        score_4: 0.2209,
        score_5: 0.4533,
      },
    },

    'overall:overall': {
      percentiles: {
        p5: 0.4248,
        p10: 0.4927,
        p15: 0.5343,
        p20: 0.5677,
        p25: 0.5926,
        p30: 0.6138,
        p35: 0.634,
        p40: 0.6552,
        p45: 0.6714,
        p50: 0.6892,
        p55: 0.7064,
        p60: 0.7219,
        p65: 0.7373,
        p70: 0.7524,
        p75: 0.7727,
        p80: 0.7912,
        p85: 0.8109,
        p90: 0.8355,
        p95: 0.8684,
        p100: 1.0,
      },
      reasons: {
        answer_quality_bot_high: 0.7422,
        answer_quality_bot_low: 0.0632,
        product_feedback_positive: 0.004,
        product_feedback_negative: 0.1224,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0424,
        user_strong_emotion_positive: 0.0046,
        user_strong_emotion_negative: 0.0538,
        user_effort_low: 0.4615,
        user_effort_high: 0.2848,
      },
      score_distribution: {
        score_1: 0.0049,
        score_2: 0.1167,
        score_3: 0.1706,
        score_4: 0.22,
        score_5: 0.4545,
      },
    },

    'overall:under_1k': {
      percentiles: {
        p5: 0.47,
        p10: 0.523,
        p15: 0.5661,
        p20: 0.5941,
        p25: 0.6257,
        p30: 0.6491,
        p35: 0.6667,
        p40: 0.6845,
        p45: 0.7014,
        p50: 0.7206,
        p55: 0.7339,
        p60: 0.75,
        p65: 0.7692,
        p70: 0.7878,
        p75: 0.803,
        p80: 0.8169,
        p85: 0.8387,
        p90: 0.8633,
        p95: 0.8958,
        p100: 0.9762,
      },
      reasons: {
        answer_quality_bot_high: 0.7667,
        answer_quality_bot_low: 0.0602,
        product_feedback_positive: 0.0,
        product_feedback_negative: 0.1224,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0238,
        user_strong_emotion_positive: 0.0,
        user_strong_emotion_negative: 0.0399,
        user_effort_low: 0.4579,
        user_effort_high: 0.274,
      },
      score_distribution: {
        score_1: 0.0,
        score_2: 0.102,
        score_3: 0.1563,
        score_4: 0.2217,
        score_5: 0.4837,
      },
    },

    'professional_services:1k_to_15k': {
      percentiles: {
        p5: 0.4823,
        p10: 0.5277,
        p15: 0.5453,
        p20: 0.5478,
        p25: 0.5685,
        p30: 0.5848,
        p35: 0.6243,
        p40: 0.6541,
        p45: 0.664,
        p50: 0.6901,
        p55: 0.7077,
        p60: 0.7219,
        p65: 0.7398,
        p70: 0.7605,
        p75: 0.7853,
        p80: 0.7884,
        p85: 0.8189,
        p90: 0.8484,
        p95: 0.874,
        p100: 0.9302,
      },
      reasons: {
        answer_quality_bot_high: 0.7557,
        answer_quality_bot_low: 0.0714,
        product_feedback_positive: 0.0043,
        product_feedback_negative: 0.1134,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0532,
        user_strong_emotion_positive: 0.007,
        user_strong_emotion_negative: 0.0442,
        user_effort_low: 0.4842,
        user_effort_high: 0.2517,
      },
      score_distribution: {
        score_1: 0.0049,
        score_2: 0.1257,
        score_3: 0.1665,
        score_4: 0.2046,
        score_5: 0.4435,
      },
    },

    'professional_services:overall': {
      percentiles: {
        p5: 0.4543,
        p10: 0.4943,
        p15: 0.5318,
        p20: 0.548,
        p25: 0.5681,
        p30: 0.586,
        p35: 0.6175,
        p40: 0.6427,
        p45: 0.656,
        p50: 0.6714,
        p55: 0.6885,
        p60: 0.712,
        p65: 0.7253,
        p70: 0.75,
        p75: 0.7598,
        p80: 0.7881,
        p85: 0.8175,
        p90: 0.8462,
        p95: 0.8762,
        p100: 0.9302,
      },
      reasons: {
        answer_quality_bot_high: 0.7528,
        answer_quality_bot_low: 0.0696,
        product_feedback_positive: 0.0016,
        product_feedback_negative: 0.1064,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.052,
        user_strong_emotion_positive: 0.0049,
        user_strong_emotion_negative: 0.041,
        user_effort_low: 0.5042,
        user_effort_high: 0.2454,
      },
      score_distribution: {
        score_1: 0.0039,
        score_2: 0.1167,
        score_3: 0.1868,
        score_4: 0.197,
        score_5: 0.4523,
      },
    },

    'real_estate:1k_to_15k': {
      percentiles: {
        p5: 0.4651,
        p10: 0.506,
        p15: 0.5553,
        p20: 0.5614,
        p25: 0.592,
        p30: 0.6029,
        p35: 0.6155,
        p40: 0.6422,
        p45: 0.6524,
        p50: 0.6634,
        p55: 0.6675,
        p60: 0.6702,
        p65: 0.6751,
        p70: 0.6777,
        p75: 0.6935,
        p80: 0.707,
        p85: 0.7265,
        p90: 0.7598,
        p95: 0.7986,
        p100: 0.8904,
      },
      reasons: {
        answer_quality_bot_high: 0.6847,
        answer_quality_bot_low: 0.0889,
        product_feedback_positive: 0.0052,
        product_feedback_negative: 0.1507,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0446,
        user_strong_emotion_positive: 0.0036,
        user_strong_emotion_negative: 0.0652,
        user_effort_low: 0.4658,
        user_effort_high: 0.3243,
      },
      score_distribution: {
        score_1: 0.007,
        score_2: 0.1563,
        score_3: 0.1967,
        score_4: 0.2157,
        score_5: 0.4221,
      },
    },

    'real_estate:overall': {
      percentiles: {
        p5: 0.4433,
        p10: 0.4698,
        p15: 0.5045,
        p20: 0.5302,
        p25: 0.56,
        p30: 0.589,
        p35: 0.6083,
        p40: 0.6212,
        p45: 0.6455,
        p50: 0.6535,
        p55: 0.664,
        p60: 0.6698,
        p65: 0.6755,
        p70: 0.6868,
        p75: 0.7038,
        p80: 0.7157,
        p85: 0.7289,
        p90: 0.7662,
        p95: 0.8124,
        p100: 0.8904,
      },
      reasons: {
        answer_quality_bot_high: 0.7002,
        answer_quality_bot_low: 0.0843,
        product_feedback_positive: 0.0044,
        product_feedback_negative: 0.1469,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.054,
        user_strong_emotion_positive: 0.0039,
        user_strong_emotion_negative: 0.0665,
        user_effort_low: 0.4591,
        user_effort_high: 0.3258,
      },
      score_distribution: {
        score_1: 0.0078,
        score_2: 0.1464,
        score_3: 0.1986,
        score_4: 0.2155,
        score_5: 0.4229,
      },
    },

    'software_and_technology:100k_to_1m': {
      percentiles: {
        p5: 0.4049,
        p10: 0.5512,
        p15: 0.5773,
        p20: 0.5878,
        p25: 0.6186,
        p30: 0.6285,
        p35: 0.6458,
        p40: 0.6609,
        p45: 0.6787,
        p50: 0.6897,
        p55: 0.7013,
        p60: 0.7139,
        p65: 0.7246,
        p70: 0.7339,
        p75: 0.7499,
        p80: 0.7564,
        p85: 0.7736,
        p90: 0.7845,
        p95: 0.8065,
        p100: 0.8824,
      },
      reasons: {
        answer_quality_bot_high: 0.7049,
        answer_quality_bot_low: 0.0775,
        product_feedback_positive: 0.0007,
        product_feedback_negative: 0.1073,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0128,
        user_strong_emotion_positive: 0.0018,
        user_strong_emotion_negative: 0.0437,
        user_effort_low: 0.3726,
        user_effort_high: 0.3407,
      },
      score_distribution: {
        score_1: 0.003,
        score_2: 0.1065,
        score_3: 0.1901,
        score_4: 0.2489,
        score_5: 0.4404,
      },
    },

    'software_and_technology:15k_to_100k': {
      percentiles: {
        p5: 0.3782,
        p10: 0.4834,
        p15: 0.5264,
        p20: 0.547,
        p25: 0.5712,
        p30: 0.5889,
        p35: 0.6023,
        p40: 0.6175,
        p45: 0.6541,
        p50: 0.6675,
        p55: 0.693,
        p60: 0.719,
        p65: 0.736,
        p70: 0.7468,
        p75: 0.7571,
        p80: 0.7726,
        p85: 0.8007,
        p90: 0.82,
        p95: 0.8418,
        p100: 0.8804,
      },
      reasons: {
        answer_quality_bot_high: 0.7249,
        answer_quality_bot_low: 0.0607,
        product_feedback_positive: 0.0037,
        product_feedback_negative: 0.1359,
        policy_feedback_positive: 0.0004,
        policy_feedback_negative: 0.036,
        user_strong_emotion_positive: 0.0052,
        user_strong_emotion_negative: 0.0662,
        user_effort_low: 0.3856,
        user_effort_high: 0.3296,
      },
      score_distribution: {
        score_1: 0.006,
        score_2: 0.1222,
        score_3: 0.1744,
        score_4: 0.2273,
        score_5: 0.4347,
      },
    },

    'software_and_technology:1k_to_15k': {
      percentiles: {
        p5: 0.4583,
        p10: 0.5187,
        p15: 0.5574,
        p20: 0.5868,
        p25: 0.612,
        p30: 0.6349,
        p35: 0.6584,
        p40: 0.6725,
        p45: 0.6909,
        p50: 0.7058,
        p55: 0.7153,
        p60: 0.7304,
        p65: 0.7431,
        p70: 0.7556,
        p75: 0.7752,
        p80: 0.7918,
        p85: 0.8073,
        p90: 0.8301,
        p95: 0.8589,
        p100: 1.0,
      },
      reasons: {
        answer_quality_bot_high: 0.7413,
        answer_quality_bot_low: 0.0614,
        product_feedback_positive: 0.0054,
        product_feedback_negative: 0.1421,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0305,
        user_strong_emotion_positive: 0.0051,
        user_strong_emotion_negative: 0.051,
        user_effort_low: 0.4246,
        user_effort_high: 0.3103,
      },
      score_distribution: {
        score_1: 0.0045,
        score_2: 0.112,
        score_3: 0.1627,
        score_4: 0.2295,
        score_5: 0.4608,
      },
    },

    'software_and_technology:overall': {
      percentiles: {
        p5: 0.4632,
        p10: 0.5214,
        p15: 0.5609,
        p20: 0.589,
        p25: 0.6137,
        p30: 0.6366,
        p35: 0.6601,
        p40: 0.6749,
        p45: 0.6937,
        p50: 0.7075,
        p55: 0.7223,
        p60: 0.7369,
        p65: 0.7492,
        p70: 0.7656,
        p75: 0.7831,
        p80: 0.7994,
        p85: 0.8172,
        p90: 0.844,
        p95: 0.8726,
        p100: 1.0,
      },
      reasons: {
        answer_quality_bot_high: 0.7449,
        answer_quality_bot_low: 0.0606,
        product_feedback_positive: 0.0039,
        product_feedback_negative: 0.1368,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0262,
        user_strong_emotion_positive: 0.0039,
        user_strong_emotion_negative: 0.0482,
        user_effort_low: 0.4211,
        user_effort_high: 0.3084,
      },
      score_distribution: {
        score_1: 0.0038,
        score_2: 0.1091,
        score_3: 0.1618,
        score_4: 0.2295,
        score_5: 0.4643,
      },
    },

    'software_and_technology:under_1k': {
      percentiles: {
        p5: 0.4842,
        p10: 0.5441,
        p15: 0.5851,
        p20: 0.614,
        p25: 0.6435,
        p30: 0.6625,
        p35: 0.6792,
        p40: 0.6957,
        p45: 0.7133,
        p50: 0.73,
        p55: 0.7433,
        p60: 0.7604,
        p65: 0.7763,
        p70: 0.7939,
        p75: 0.8083,
        p80: 0.8259,
        p85: 0.851,
        p90: 0.8702,
        p95: 0.9029,
        p100: 0.9762,
      },
      reasons: {
        answer_quality_bot_high: 0.77,
        answer_quality_bot_low: 0.0568,
        product_feedback_positive: 0.0,
        product_feedback_negative: 0.1267,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.019,
        user_strong_emotion_positive: 0.0,
        user_strong_emotion_negative: 0.0364,
        user_effort_low: 0.4321,
        user_effort_high: 0.2849,
      },
      score_distribution: {
        score_1: 0.0,
        score_2: 0.1003,
        score_3: 0.1518,
        score_4: 0.2283,
        score_5: 0.4852,
      },
    },

    'telecommunications:overall': {
      percentiles: {
        p5: 0.451,
        p10: 0.4691,
        p15: 0.4983,
        p20: 0.5,
        p25: 0.5038,
        p30: 0.519,
        p35: 0.5335,
        p40: 0.5467,
        p45: 0.5896,
        p50: 0.627,
        p55: 0.6592,
        p60: 0.6646,
        p65: 0.6835,
        p70: 0.7083,
        p75: 0.719,
        p80: 0.7236,
        p85: 0.7431,
        p90: 0.7574,
        p95: 0.7827,
        p100: 0.8244,
      },
      reasons: {
        answer_quality_bot_high: 0.6674,
        answer_quality_bot_low: 0.0729,
        product_feedback_positive: 0.0038,
        product_feedback_negative: 0.1298,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.068,
        user_strong_emotion_positive: 0.0069,
        user_strong_emotion_negative: 0.0938,
        user_effort_low: 0.4034,
        user_effort_high: 0.3411,
      },
      score_distribution: {
        score_1: 0.008,
        score_2: 0.1484,
        score_3: 0.2011,
        score_4: 0.219,
        score_5: 0.3939,
      },
    },

    'transportation:1k_to_15k': {
      percentiles: {
        p5: 0.4141,
        p10: 0.461,
        p15: 0.475,
        p20: 0.5144,
        p25: 0.5343,
        p30: 0.5591,
        p35: 0.5745,
        p40: 0.5989,
        p45: 0.6107,
        p50: 0.6218,
        p55: 0.6443,
        p60: 0.6797,
        p65: 0.6874,
        p70: 0.7215,
        p75: 0.7311,
        p80: 0.7653,
        p85: 0.7875,
        p90: 0.7921,
        p95: 0.8249,
        p100: 0.9053,
      },
      reasons: {
        answer_quality_bot_high: 0.7139,
        answer_quality_bot_low: 0.0859,
        product_feedback_positive: 0.0019,
        product_feedback_negative: 0.0789,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.0608,
        user_strong_emotion_positive: 0.0022,
        user_strong_emotion_negative: 0.0532,
        user_effort_low: 0.4699,
        user_effort_high: 0.2559,
      },
      score_distribution: {
        score_1: 0.0073,
        score_2: 0.1471,
        score_3: 0.1942,
        score_4: 0.2172,
        score_5: 0.3959,
      },
    },

    'transportation:overall': {
      percentiles: {
        p5: 0.4141,
        p10: 0.4707,
        p15: 0.4853,
        p20: 0.527,
        p25: 0.5403,
        p30: 0.5636,
        p35: 0.5916,
        p40: 0.5988,
        p45: 0.613,
        p50: 0.6241,
        p55: 0.641,
        p60: 0.6841,
        p65: 0.7121,
        p70: 0.7281,
        p75: 0.7395,
        p80: 0.7682,
        p85: 0.7874,
        p90: 0.8067,
        p95: 0.8239,
        p100: 0.9053,
      },
      reasons: {
        answer_quality_bot_high: 0.7234,
        answer_quality_bot_low: 0.0862,
        product_feedback_positive: 0.0024,
        product_feedback_negative: 0.0756,
        policy_feedback_positive: 0.0,
        policy_feedback_negative: 0.08,
        user_strong_emotion_positive: 0.0023,
        user_strong_emotion_negative: 0.0533,
        user_effort_low: 0.4797,
        user_effort_high: 0.2586,
      },
      score_distribution: {
        score_1: 0.0074,
        score_2: 0.1363,
        score_3: 0.1936,
        score_4: 0.2123,
        score_5: 0.4005,
      },
    },
  },
};
